export default function NotificationProduction({ todo }) {
	const { content } = todo;

	if (!content.production) {
		return null;
	}

	return <p>{`${content.production.title} (${content.publisher?.name})`}</p>;
}
